/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("AccordionFolderWidget", ["FolderWidgetBase"], function (context, cls) {
  /**
   * Accordion Folder widget.
   * @class AccordionFolderWidget
   * @memberOf classes
   * @extends classes.FolderWidgetBase
   * @publicdoc Widgets
   */
  cls.AccordionFolderWidget = context.oo.Class(cls.FolderWidgetBase, function ($super) {
    return /** @lends classes.AccordionFolderWidget.prototype */ {
      __name: "AccordionFolderWidget",

      /**
       * @inheritDoc
       */
      _initElement: function () {
        $super._initElement.call(this);

        // Set the default value of the collapsers to the theme definition
        this.setCollapserPosition(gbc.ThemeService.getValue("gbc-AccordionFolderWidget-collapser-position"));
      },

      /**
       * @inheritDoc
       */
      _initLayout: function () {
        this._layoutInformation = new cls.LayoutInformation(this);
        this._layoutEngine = new cls.AccordionFolderLayoutEngine(this);

        $super._initLayout.call(this);
      },

      /**
       * @inheritDoc
       * @param {cls.pageWidget} widget The page widget to add as a child
       */
      addChildWidget: function (widget, options) {
        options = options || {};
        options.noDOMInsert = true;

        const titleWidget = widget.getTitleWidget();
        // switch the title's ARIA semantics from tablist tab to accordion header
        titleWidget.setAccordionMode(true);

        const accordionElement = document.createElement("div");
        accordionElement.classList.add("gbc_AccordionElement", "g_measurable");

        const accordionPage = document.createElement("div");
        accordionPage.classList.add("gbc_AccordionPage", "g_measurable");

        accordionElement.appendChild(titleWidget.getElement());
        accordionPage.appendChild(widget.getElement());
        accordionElement.appendChild(accordionPage);

        this.getContainerElement().appendChild(accordionElement);

        this.pageVisibilityUpdated();

        $super.addChildWidget.call(this, widget, options);
      },

      /**
       * @inheritDoc
       */
      removeChildWidget: function (widget) {
        const accordionPage = widget.getElement().parentNode;
        // only current page is in DOM
        if (accordionPage) {
          const accordionElement = accordionPage.parentNode;
          accordionPage.remove();
          if (accordionElement) {
            accordionElement.remove();
          }
        }

        $super.removeChildWidget.call(this, widget);
      },

      /**
       * @inheritDoc
       */
      setCurrentPage: function (page, executeAction = false, fromUserAction = false) {
        let accordionElement = null;
        let accordionPage = null;
        if (this._currentPage && this._currentPage !== page) {
          // remove currentPage class from previous current accordion page
          accordionPage = this._currentPage.getElement().parentNode;
          accordionElement = accordionPage.parentNode;
          accordionPage.classList.remove("currentPage");
          accordionElement.classList.remove("currentPage");
        }
        const modified = $super.setCurrentPage.call(this, page, executeAction, fromUserAction);
        if (modified) {
          // add currentPage class to new current accordion page
          accordionPage = this._currentPage.getElement().parentNode;
          accordionElement = accordionPage.parentNode;
          accordionPage.classList.add("currentPage");
          accordionElement.classList.add("currentPage");
          // aria-expanded is updated by PageTitleWidget.setCurrent (accordion mode dispatch)
          // through the loop in FolderWidgetBase.setCurrentPage
        }
        return modified;
      },

      /**
       * Define the position of the collapser
       * @param {string} pos - could be 'left' or 'right' (default)
       */
      setCollapserPosition: function (pos) {
        this.removeClass("collapser-position-left");
        this.removeClass("collapser-position-right");
        this.addClasses("collapser-position-" + pos);
      }
    };
  });
  cls.WidgetFactory.registerBuilder("Folder[position=accordion]", cls.AccordionFolderWidget);
});
